interface BillingRequest {
	service_id: string
}

export default class Payment {
	constructor(
		public id: number,
		public currency: string,
		public amount: number,
		public charge_date: Date,
		public paid: boolean,
		public service: string,
		public service_id: string,
		public billing_request: BillingRequest,
	) {}
}
